import {css, unsafeCSS} from 'lit';
import {sbkCoreBreakpointLg} from "@/tokens/variables";

const breakpointLg = unsafeCSS(`${sbkCoreBreakpointLg}`);
export const autoLogoutStyle = css`
    .time {
        display: inline-block;
        width: 38px;
        @media all and (min-width: ${breakpointLg}) {
            width: 43px;
        }
    }
`;
